<button type="button" mat-raised-button (click)="fileInput.click()">Choose File</button>
<input hidden (change)="uploadFile($event)" #fileInput type="file" id="file">
